import { Component } from 'react';
import cx from 'classnames';
import { getYear } from 'date-fns';
import I18n from '../../../config/i18n';
import * as routePath from '../../common/utils/routePath';

export default class Footer extends Component {
  render() {
    return (
      <div
        className={cx('app__footer', {
          app__footer__landing_page:
            this.props.location.pathname === routePath.homeRoute,
        })}
      >
        <span>{I18n.t('footerCopyright', { year: getYear(new Date()) })}</span>|
        <a
          href="https://www.qubewire.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          Qube Wire
        </a>
      </div>
    );
  }
}
